<template>
  <div class="d-flex w-auto">
    <a-form-item :wrapperCol="{ span: 24 }">
      <base-select
        v-decorator="decorator.resource_type"
        class="w-100"
        resource="bill_conditions"
        version="v1"
        idKey="item_id"
        nameKey="item_name"
        :remote="true"
        :needParams="true"
        :params="conditionParams"
        :remote-fn="q => ({ filter: [`item_name.contains(${q})`, `brand.equals(google)`] })"
        :select-props="{ placeholder: $t('scope.text_507')}"
        @change="resourceTypeChange" />
    </a-form-item>
    <a-form-item :wrapperCol="{ span: 24 }" class="ml-2">
      <a-input v-decorator="decorator.price" :suffix="resource_type === 'cdn' ? $t('scope.text_510') : '%'" />
    </a-form-item>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'DiscountInfo',
  props: {
    decorator: {
      type: Object,
      required: true,
      validator: val => val.resource_type && val.price,
    },
  },
  data () {
    return {
      conditionParams: {
        scope: this.scope,
        admin: true,
        query_type: 'resource_type_sku',
        limit: 10,
      },
      resource_type: 'all',
    }
  },
  computed: {
    ...mapGetters(['scope']),
  },
  methods: {
    resourceTypeChange (e) {
      this.resource_type = e
    },
  },
}
</script>
